import { Box, createStyles, withStyles } from '@material-ui/core';

export const Wrapper = withStyles(({ spacing }) =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'center',
      padding: spacing(1),
    },
  })
)(Box);
